import { useEffect } from 'react'
import CheckCertificateModal from '../../../components/check-certificate-modal/index.jsx'
import {
  Loader,
  LoaderWrapper
} from '../../../components/page-loader/styled-components.js'
import { useMtlsCertificateStore } from '../../../zustand/mtls-certificate/use-mtls-certificate-store.jsx'
import { useCheckCertificate } from '../../../react-query/certificate-modal/queries/use-check-certificate.jsx'

export const AppMtlsCertWrapper = ({ children, isLoggedIn }) => {
  const { setIsMtlsRequired, isMtlsRequired } = useMtlsCertificateStore()

  const { refetch, isLoading, isSuccess, error } = useCheckCertificate({
    enabled: !!isLoggedIn && isMtlsRequired
  })

  useEffect(() => {
    if (error && error.response && error.response.status === 404) {
      return setIsMtlsRequired(false)
    }
  }, [error])

  useEffect(() => {
    if (
      isSuccess ||
      (error?.code !== 'ERR_NETWORK' &&
        error?.code !== 'ERR_CERT_AUTHORITY_INVALID')
    ) {
      return setIsMtlsRequired(false)
    }
  }, [isSuccess, error])

  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader className="loader" />
      </LoaderWrapper>
    )
  }

  if (isLoggedIn && isMtlsRequired) {
    return (
      <CheckCertificateModal
        isSuccess={isSuccess}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
      />
    )
  }

  return children
}
